import React, { useState, Fragment } from 'react';
import { View, Text, SafeAreaView } from 'react-native';
import { storiesOf } from '@storybook/react-native';
import { PanelHeader, PanelHeaderClose } from 'src/components/PanelHeader';
import { PlatformPadding } from 'src/components/PlatformPadding';
import { Button } from 'src/components/Button';
import { Popout } from 'src/components/Popout';

const Example1 = () => {
  const [active, toggle] = useState(false);

  return (
    <Fragment>
      <PanelHeader>💬 Popout</PanelHeader>
      <PlatformPadding vertical horizontal>
        <View>
          <Button onPress={() => toggle(true)}>Show</Button>
        </View>
      </PlatformPadding>
      <Popout
        visible={active}
        onRequestClose={() => toggle(false)}
        onDismiss={() => console.log('popout dismissed')}
      >
        <SafeAreaView>
          <View style={{ backgroundColor: '#ffffff' }}>
            <PanelHeader
              right={<PanelHeaderClose onPress={() => toggle(false)}>Cancel</PanelHeaderClose>}
            >
              Example Popout
            </PanelHeader>
            <PlatformPadding horizontal vertical>
              <View style={{ backgroundColor: '#fff' }}>
                <Text>Basic component for all kinds of Popup" things</Text>
              </View>
            </PlatformPadding>
          </View>
        </SafeAreaView>
      </Popout>
    </Fragment>
  );
};

storiesOf('Popout', module).add('Default', () => <Example1 />);
